import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import GenericListSearchTab from "./../../factories/generic-list-search-tab";
class ConfigurationItem150Characteristic extends GenericListSearchTab {
    SearchType(): string {
        return "ConfigurationItemTypeCategory";
    }
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }
    CustomFilter() {
        return null;
    }
}
export default ConfigurationItem150Characteristic;